import React, { Component } from "react";

class Spinner extends Component {
    constructor(params) {
        super(params);
    }

    render() {

        return (
            <div id="spinnerDiv" style={this.props.style}>
                <div className={this.props.fullWidth ? "" : "maxWidth-content"}>
                    <div className="doubleSpinner">
                        <div className="outerRing" />
                        <div className="innerRing" />
                        <div className="spinner-bg" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Spinner;